import { createSelector } from 'reselect'
import * as constants from "./constants"

const root = state => state.get('enrichment')
const status = state => root(state).status
const companyDataStatus = (state, props) => {
  return status(state).get(`${props.ip}-${props.email}`)
}
const isDataLoaded = (status) => status === constants.FETCH_ENRICHED_COMPANY_DATA_SUCCESS ||
  status === constants.FETCH_ENRICHED_COMPANY_DATA_NO_RESULT ||
  status === constants.FETCH_ENRICHED_COMPANY_DATA_FAILED
const isDataLoading = (status) => status === constants.FETCH_ENRICHED_COMPANY_DATA ||
  status === constants.FETCH_ENRICHED_COMPANY_DATA_PENDING
const eligibleDataForClearbitTrial = [
  ['name', 'domain'],
  'linkedInHandle',
  'description',
  'employeeCount',
  'moneyRaised',
  'marketCap',
  'industry',
  'tags'
]
const eligibiltyCheck = (conditions, source) => {
  conditions.map(condition => {
    if (Array.isArray(condition)) {
      return _.compact(eligibiltyCheck(condition, source))
    }
    return source.contains(condition)
  })
}

export const companyDataByIp = (state, props) => {
  return root(state).company.get(props.ip)
}

export const endUserCompanyData = (state, props) => {
  return root(state).companyByEndUserId.get(props.endUserId)
}

export const enrichmentByConversationId = (state, props) => {
  const enrichmentSourceId = root(state).enrichmentSourcesByConversationId.get(`${props.conversationId}`)
  return root(state).company.get(`${enrichmentSourceId}`)
}

export const companyData = (state, props) => {
  return root(state).company.get(`${props.ip}-${props.email}`)
}

export const getIsICP = (state, props) => {
  const data = companyData(state, props)
  if (!data) {
    return false
  }
  const employeeCountCondition = data.get('employeeCount') >= 150
  const marketoCondition = data.get('tech').includes('marketo')
  const salesforceCondition = data.get('tech').includes('salesforce')
  return employeeCountCondition && marketoCondition && salesforceCondition
}

export const isCompanyDataLoaded = createSelector(
  [companyDataStatus],
  (status) => isDataLoaded(status)
)

export const isCompanyDataLoading = createSelector(
  [companyDataStatus],
  (status) => isDataLoading(status)
)

export const companyDataJS = createSelector(
  [companyData],
  (data) => {
    if (!data) {
      return null
    }
    return data.toJS()
  }
)

export const endUserCompanyDataJS = createSelector(
  [endUserCompanyData],
  (data) => {
    if (!data) {
      return null
    }
    return data.toJS()
  }
)

export const decodedConditions = state => root(state).decodedConditions
export const makeHasRequestedDecodedCondition = (state) => (condition) => decodedConditions(state).has(condition)
const getDecodedConditionRoot = (state, condition) => decodedConditions(state).get(condition)
export const getDecodedConditionStatus = (state, condition) => getDecodedConditionRoot(state, condition).get('status')
export const getDecodedCondition = (state, condition) => getDecodedConditionRoot(state, condition).get('data')

export const hasMinimumRevealDataForClearbitTrialOffer = createSelector(
  companyDataByIp,
  (data) => {
    if (!data) {
      return false
    }
    return _.compact(eligibiltyCheck(eligibleDataForClearbitTrial, data)).length >= 5
  })



// WEBPACK FOOTER //
// ./src/scripts/app/modules/enrichment/selectors.js